import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import WizardContent from '~/layouts/WizardContent';
import LeftLayout from '~/layouts/LeftLayout';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import features from '~/constants/features';
import { SubmitStageImg } from '~/img';
import CompletionContainer from '~/pages/ksa/completion/components/CompletionContainer';

const AgentAutomatedOnboarding: FC = () => {
  const { t } = useTranslation('ksaCompletion');

  return (
    <CompletionContainer>
      <Typography.Title className="Completion-Title">
        {t('Automated onboarding is in progress')}
      </Typography.Title>
      <Typography.Paragraph className="Completion-Paragraph">
        {t(
          'This application has been successfully approved and the merchant onboarding is in progress. Please wait.'
        )}
      </Typography.Paragraph>
      <SubmitStageImg className="Completion-Img" />
    </CompletionContainer>
  );
};

export default AgentAutomatedOnboarding;
